import current from './current'
import { updateUnits, updateAuthApp } from './update'
import { updateSettings } from './settings'
import searchDeptAdmin from './searchDeptAdmin'

export default {
  current,
  updateUnits,
  updateAuthApp,
  updateSettings,
  searchDeptAdmin,
}
